import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Client from "../utils/client";
import { toast } from "react-toastify";
import { api_url } from "../constant";
import { FeedbackIcon } from "../icons/feedback";
import { motion, AnimatePresence } from "framer-motion";

function Inquiry() {
  const [succeeded, setSucceeded] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    await Client.post(api_url + "/feedbacks", data)
      .then((res) => setSucceeded(true))
      .catch((e) => toast("الرجاء التأكد من البيانات", { type: "error" }));
  };

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          dir="rtl"
          className="border-primary rounded-3xl transition-all border shadow-2xl w-full lg:w-[25rem] p-6 bg-black/5 flex flex-col gap-3 backdrop-blur-lg"
        >
          <AnimatePresence>
            {succeeded ? (
              <motion.div
                initial={{ opacity: 0 }}
                exit={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay:0.2 }}
                className="h-52 transition-all text-center flex justify-center items-center flex-col gap-10"
              >
                <h1 className="text-2xl font-bold">
                  {" "}
                  رأيك مهم , نسعد لخدمتك :)
                </h1>
                <div className=""> {FeedbackIcon}</div>
              </motion.div>
            ) : (
              <>
                <div className="flex flex-col gap-2">
                  <label className="font-bold after:content-['*'] after:mr-0.5 after:text-red-500">
                    رقم الهاتف
                  </label>
                  <input
                    type="number"
                    dir="ltr"
                    {...register("phonenumber", { required: true })}
                    className="border-[2px] h-9 text-end p-1 rounded-lg placeholder:p-0  border-secondary focus:ring-0 focus-within:border-primary placeholder:text-sm placeholder-opacity-20"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="font-bold after:content-['*'] after:mr-0.5 after:text-red-500">
                    البريد الإلكتروني
                  </label>
                  <input
                    type="email"
                    {...register("email", { required: true })}
                    className="border-[2px] h-9  p-1 rounded-lg  border-secondary focus:ring-0 focus-within:border-primary"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="font-bold after:content-['*'] after:mr-0.5 after:text-red-500">
                    الإستعلامات أو المقترحات
                  </label>
                  <textarea
                    {...register("inquiry", { required: true })}
                    className="border-[2px] h-28 resize-none p-2 rounded-lg  border-secondary focus:ring-0 focus-within:border-primary"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="rounded-full bg-primary text-white w-1/3 h-9 mx-auto font-bold mt-2 hover:scale-110 transition transform"
                >
                  إرسال
                </button>
              </>
            )}
          </AnimatePresence>
        </div>
      </form>
    </div>
  );
}

export default Inquiry;
